module.exports = __webpack_public_path__ + "static/media/home-category-7.479c6aba.png";